export default "__VITE_ASSET__2eb2e24e__"